export default "__VITE_ASSET__DG7g$CNA__"